import React from 'react';
import styles from './AccountDetails.module.scss';

import {FaEdit} from 'react-icons/fa';
import {FiInfo} from 'react-icons/fi';
import {HiOutlineMail, HiOutlineUserCircle, HiOutlineKey} from 'react-icons/hi';
import {IoLanguage, IoTimeOutline} from 'react-icons/io5';
import _ from "lodash";
import {$t} from "../../helpers/translator";
import {$getLanguages} from "../../helpers/translator";
import api from "../../helpers/api";
import Loader from "../miscellaneous/Loader/Loader";
import Tooltip from "../miscellaneous/Tooltip/Tooltip";
import Modal from "../miscellaneous/Modal/Modal";
import MultiSelect from "../miscellaneous/MultiSelect/MultiSelect";
import {getUser} from "../../store/auth-slice";
import {connect} from "react-redux";
import moment from "moment-timezone";
import {getShortListOfTimezones} from "../../helpers/helpers";
import store from "../../store";
import Input from "../miscellaneous/Input/Input";
import PasswordChange from "../PasswordChange/PasswordChange";

class AccountDetails extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            clinicId: this.props.clinicId ? this.props.clinicId : null, //for specific clinic data (as chain/distributor/admin)
            distributorId: this.props.distributorId ? this.props.distributorId : null, //for specific distributor data (as admin),
            userId: null, //Stores the user id of the user connected to SmartClinic
            details: null,
            languages: null,
            selectedLanguage: {
                label: 'English',
                value: 'en'
            },

            showEditName: false,
            showEditEmail: false,
            showEditPassword: false,

            currentData: {
                email: '',
                fullName: '',
            },

            formsData: {
                name: '',
                email: '',
                passwordCurrent: '',
                passwordNew: '',
                passwordNewConfirm: '',
            },
            formsDataErrors: {
                name: '',
                email: '',
                passwordCurrent: '',
                passwordNew: '',
                passwordNewConfirm: '',
            },
            formsErrors: {
                name: '',
                email: '',
                password: '',
            },

            loading: false,
            success: false,

            timezonesOptions: [],
            selectedTimezone: null
        };
    }

    async componentDidMount() {
        await this.getMyDetails();
        this.getTimeZoneOptions();

        let userId = store.getState().auth.user.id;     //This is the id of the user currently signed in. used for username changes.

        let currentLang = localStorage.getItem('almaLang') ? localStorage.getItem('almaLang') : 'en';
        let langOptions = $getLanguages();
        let languages = [];
        _.forEach(langOptions, (v, k) => {
            languages.push({
                label: v,
                value: k
            });
        });

        let i = _.findIndex(languages, function (o) {
            return o.value === currentLang;
        });
        let selectedLanguage = languages[i];

        this.setState({
            selectedLanguage: selectedLanguage,
            languages: languages,
            userId: userId,
            // timeZones: timeZones,
        });
    }

    languageChangeHandler(data) {
        // console.log(data);
        this.setState({selectedLanguage: data}, () => {
            // cookies.utils.setLang(data.value);
            localStorage.setItem('almaLang', data.value);
            window.location.reload();
        });
    }

    async getMyDetails() {
        let user = null;

        try {
            if (this.props.clinicId || this.props.userType === 5) {
                let res = await api.get(`account/user?clinic_id=${this.props.clinicId}&user_id=${this.props.userId}`);
                if (res && res.success) {
                    user = res.data.data;
                }
            } else {
                user = await this.props.dispatch(getUser())
            }

            this.setState({
                currentData: {
                    email: user.email,
                    fullName: user.name,
                    timezone: user.timezone
                }
            });
        } catch (e) {
            console.error('err getting user', e)
        }
    }

    getTimeZoneOptions() {
        let timezoneNames = moment.tz.names();

        let timeZones = [];
        _.forEach(timezoneNames, (v, k) => {
            timeZones.push({
                offsetText: moment.tz(v).format('Z'),
                offset: moment.tz(v).utcOffset(),
                label: (`[GMT ${moment.tz(v).format('Z')}] ${v}`).replace('_', ' ').replace('/', ' / '),
                value: v,
            })
        })
        let orderedTimezones = _.orderBy(timeZones, ['offset', 'value'], ['asc', 'asc']);
        let filteredOrderedTimezones = _.filter(orderedTimezones, function (o) {
            return o.value.split('/').length === 2 && !o.value.includes('GMT');
        });

        let userTimeZoneText = store.getState().auth.user.timezone;
        let selectedTimezone = {
            offsetext: $t('global.general.notSelected'),
            offset: 0,
            label: $t('global.general.notSelected'),
            value: null
        };
        if (userTimeZoneText) {
            let userTimezoneObj = _.find(filteredOrderedTimezones, function (o) {
                return o.value === userTimeZoneText
            })
            if (userTimezoneObj) {
                selectedTimezone = userTimezoneObj
            }
        }

        this.setState({timezonesOptions: filteredOrderedTimezones, selectedTimezone: selectedTimezone})
    }

    async timezoneChangeHandler(data) {
        // console.log(data)

        let res = await api.post('/account', {
            timezone: data.value
        })
        // console.log(res)

        this.setState({selectedTimezone: data}, () => {
            // console.log(data, this.state)
        });
    }

    closeModals() {
        let formsData = {...this.state.formsData};
        let formsDataErrors = {...this.state.formsDataErrors};

        _.forEach(formsData, (v, k) => {
            // console.log(k);
            formsData[k] = '';
            formsDataErrors[k] = '';
        });

        this.setState({
            showEditName: false,
            showEditEmail: false,
            showEditPassword: false,
            formsData: formsData,
            formsDataErrors: formsDataErrors,
            success: false,
            formsErrors: {
                name: '',
                email: '',
                password: '',
            }
        });
    }

    fieldChangeHandler(e) {
        let formsData = {...this.state.formsData};
        formsData[e.target.name] = e.target.value;
        this.setState({formsData: formsData});
    }

    async changeName() {
        let formsDataErrors = {...this.state.formsDataErrors};
        formsDataErrors.name = '';

        if (!this.state.formsData.name) {
            formsDataErrors.name = $t('validation.general.required');
        }

        this.setState({formsDataErrors: formsDataErrors}, async () => {
            if (!formsDataErrors.name) {
                this.setState({loading: true}, async () => {
                    // let res = await api.changeClinicAccountName({ userName: this.state.formsData.name });
                    let res = await api.post('/account/username', {
                        clinic_id: this.state.clinicId,
                        user_id: this.state.userId,             //ID of the user connected.
                        userName: this.state.formsData.name,
                    })
                    // console.log('res' , res)
                    if (res && res.data && res.data.success) {
                        this.setState({
                            success: true,
                            loading: false
                        }, async () => {
                            await this.getMyDetails();
                        });
                    } else {
                        let formsErrors = {...this.state.formsErrors};
                        formsErrors.name = res && res.data && res.data.error && res.data.error.errorText ? res.data.error.errorText : 'Error occurred while updating name';
                        this.setState({
                            loading: false,
                            formsErrors: formsErrors
                        });
                    }
                    // console.log(res.data);
                });
            } else {
                console.error('errors found');
            }
        });
    }

    // async changeEmail() {
    //     let formsDataErrors = { ...this.state.formsDataErrors };
    //     formsDataErrors.email = '';
    //     formsDataErrors.passwordCurrent = '';
    //
    //     // Email validation:
    //     let reg = /\S+@\S+\.\S+/;
    //     if (!this.state.formsData.email) {
    //         formsDataErrors.email = $t('validation.general.required');
    //     } else if (!reg.test(this.state.formsData.email)) {
    //         formsDataErrors.email = $t('validation.general.email');
    //     }
    //
    //     // current password validation:
    //     if (!this.state.formsData.passwordCurrent) {
    //         formsDataErrors.passwordCurrent = $t('validation.general.required');
    //     }
    //
    //     this.setState({ formsDataErrors: formsDataErrors }, async () => {
    //         if (!formsDataErrors.email && !formsDataErrors.passwordCurrent) {
    //             this.setState({ loading: true }, async () => {
    //                 let res = await api.postNew('/account/email', {
    //                     clinic_id: this.state.clinicId,
    //                     clinicEmail: this.state.formsData.email,
    //                     userPassword: this.state.formsData.passwordCurrent
    //                 })
    //                 // let res = await api.changeClinicAccountEmail({
    //                 //     clinicEmail: this.state.formsData.email,
    //                 //     userPassword: this.state.formsData.passwordCurrent
    //                 // });
    //
    //                 console.log('res' , res)
    //                 if (res && res.data && res.data.success) {
    //                     this.setState({
    //                         success: true,
    //                         loading: false
    //                     }, async () => {
    //                         await this.getMyDetails();
    //                     });
    //                 } else {
    //                     let formsErrors = { ...this.state.formsErrors };
    //                     formsErrors.email = res && res.data && res.data.error && res.data.error.errorText ? res.data.error.errorText : 'Error occurred while updating email';
    //                     this.setState({
    //                         loading: false,
    //                         formsErrors: formsErrors
    //                     });
    //                 }
    //             });
    //         } else {
    //             // console.log('errors found');
    //         }
    //     });
    //
    // }

    // async changePassword() {
    //     let formsDataErrors = {...this.state.formsDataErrors};
    //     formsDataErrors.passwordCurrent = '';
    //     formsDataErrors.passwordNew = '';
    //     formsDataErrors.passwordNewConfirm = '';
    //
    //     if (!this.state.formsData.passwordCurrent) {
    //         formsDataErrors.passwordCurrent = $t('validation.general.required');
    //     }
    //     if (!this.state.formsData.passwordNew) {
    //         formsDataErrors.passwordNew = $t('validation.general.required');
    //     } else if (this.state.formsData.passwordNew.length < 6) {
    //         formsDataErrors.passwordNew = $t('validation.password.length');
    //     }
    //     if (!this.state.formsData.passwordNewConfirm) {
    //         formsDataErrors.passwordNewConfirm = $t('validation.general.required');
    //     } else if (this.state.formsData.passwordNewConfirm !== this.state.formsData.passwordNew) {
    //         formsDataErrors.passwordNewConfirm = $t('validation.password.noMatch');
    //     }
    //
    //     this.setState({formsDataErrors: formsDataErrors}, async () => {
    //         if (!formsDataErrors.passwordCurrent && !formsDataErrors.passwordNew && !formsDataErrors.passwordNewConfirm) {
    //             this.setState({loading: true}, async () => {
    //                 // let res = await api.changeClinicAccountPassword({
    //                 //     userPassword: this.state.formsData.passwordCurrent,
    //                 //     newPassword: this.state.formsData.passwordNew
    //                 // });
    //                 let res = await api.post('/account/password', {
    //                     clinic_id: this.state.clinicId,
    //                     userPassword: this.state.formsData.passwordCurrent,
    //                     newPassword: this.state.formsData.passwordNew
    //                 })
    //                 // console.log('res' , res)
    //                 if (res && res.data && res.data.success) {
    //                     this.setState({
    //                         success: true,
    //                         loading: false
    //                     }, async () => {
    //                         await this.getMyDetails();
    //                     });
    //                 } else {
    //                     let formsErrors = {...this.state.formsErrors};
    //                     formsErrors.password = res && res.data && res.data.error && res.data.error.errorText ? res.data.error.errorText : 'Error occurred while updating password';
    //                     this.setState({
    //                         loading: false,
    //                         formsErrors: formsErrors
    //                     });
    //                 }
    //             });
    //         } else {
    //             console.error('errors found');
    //         }
    //     });
    // }

    renderEditName() {
        return (
            <div>

                {this.state.success ?
                    <div
                        className={`${styles['success-message']}`}>{$t('global.myDetails.nameUpdatedSuccessfully')}</div>
                    :
                    <div>
                        <div className={`${styles['row']}`}>
                            <div className={`${styles['rodal-header']}`}>{$t('global.myDetails.editName')}</div>
                        </div>
                        <div className={`${styles['row-form']}`}>
                            <div>{$t('global.myDetails.currentName')}</div>
                            <div className={`${styles['input-container']}`}>
                                <input name="staffId"
                                       className={'alma-input'}
                                       disabled
                                       type="text"
                                       value={this.state.currentData.fullName}/>
                            </div>
                        </div>

                        <div className={`${styles['row-form']}`}>
                            <div>{$t('global.myDetails.newName')}</div>
                            <div className={`${styles['input-container']}`}>
                                <input name="name"
                                       className={'alma-input'}
                                       type="text"
                                       value={this.state.formsData.name}
                                       onChange={(e) => this.fieldChangeHandler(e)}/>
                            </div>
                        </div>
                        <div className={`${styles['error-text']}`}>{this.state.formsDataErrors.name}</div>

                        {this.state.loading ?
                            <Loader/>
                            :
                            <div className={`${styles['row']} ${styles['flex-end']}`}>
                                <div className={'alma-button'}
                                     onClick={() => this.changeName()}>{$t('global.myDetails.changeName')}
                                </div>
                            </div>
                        }
                        <div className={`${styles['row']} ${styles['error-text']}`}>
                            {this.state.formsErrors.name}
                        </div>
                    </div>
                }
            </div>
        )
    }

    render() {
        let userType = this.props.userType ? this.props.userType : 2;

        return (
            <div className={`${styles['container']} alma-box`}>
                <div className={`alma-box-header`}>
                    <span><h3>{$t('global.myDetails.accountDetails')}</h3></span>
                    <Tooltip
                        content={$t('global.myDetails.accountDetailsInfo')}>
                        <FiInfo className={`${styles['info-icon']}`}/>
                    </Tooltip>
                </div>

                <div>
                    <div className={`${styles['row']}`}>
                        <HiOutlineUserCircle className={`${styles['data-icon']}`}/>
                        <div className={`${styles['header']}`}>{$t('global.myDetails.fullName')}:</div>
                        <div className={`${styles['value']}`}>{this.state.currentData.fullName}</div>
                        {!this.props.clinicId && !this.props.distributorId ?
                            <FaEdit className={`${styles['edit-icon']}`}
                                    onClick={() => this.setState({showEditName: true})}/>
                            :
                            null}
                    </div>
                    <div className={`${styles['row']}`}>
                        <HiOutlineMail className={`${styles['data-icon']}`}/>
                        <div className={`${styles['header']}`}>{$t('global.myDetails.email')}:</div>
                        <div className={`${styles['value']}`}>{this.state.currentData.email}</div>
                        {/*<FaEdit className={`${styles['edit-icon']}`} onClick={() => this.setState({ showEditEmail: true })}/>*/}
                    </div>
                    <div className={`${styles['row']}`}>
                        <HiOutlineKey className={`${styles['data-icon']}`}/>
                        <div className={`${styles['header']}`}>{$t('global.myDetails.password')}:</div>
                        <div className={`${styles['value']}`}>*******</div>
                        {!this.props.clinicId && !this.props.distributorId ?
                            <FaEdit className={`${styles['edit-icon']}`}
                                    onClick={() => this.setState({showEditPassword: true})}/>
                            :
                            null}
                    </div>

                    {!this.props.clinicId && !this.props.distributorId ?
                    <>
                        <div className={`${styles['row']}`}>
                            <IoLanguage className={`${styles['data-icon']}`}/>
                            <div className={`${styles['header']}`}>{$t('global.myDetails.language')}:</div>
                            <div className={`${styles['value']} ${styles['select']}`}>
                                <MultiSelect
                                    searchable
                                    name="language"
                                    options={this.state.languages}
                                    selected={this.state.selectedLanguage}
                                    onValueChange={(data) => this.languageChangeHandler(data)}
                                />
                            </div>
                        </div>

                        <div className={`${styles['row']}`}>
                            <IoTimeOutline className={`${styles['data-icon']}`}/>
                            <div className={`${styles['header']}`}>{$t('global.myDetails.timezone')}:</div>
                            <div className={`${styles['value']} ${styles['select']}`}>
                                <MultiSelect
                                    searchable={true}
                                    name="timezoneeeee"
                                    options={this.state.timezonesOptions}
                                    selected={this.state.selectedTimezone}
                                    onValueChange={(data) => this.timezoneChangeHandler(data)}
                                />
                            </div>
                        </div>
                    </>
                    :
                    null
                    }
                </div>

                {/*modals:*/}
                <Modal content={this.renderEditName()}
                       onClose={this.closeModals.bind(this)}
                       visible={this.state.showEditName}/>

                {/*<Modal content={this.renderEditEmail()}*/}
                {/*       onClose={this.closeModals.bind(this)}*/}
                {/*       visible={this.state.showEditEmail} />*/}

                <Modal content={<PasswordChange clinicId={this.props.clinicId} reset={this.state.showEditPassword}/>}
                       onClose={this.closeModals.bind(this)}
                       visible={this.state.showEditPassword}/>
            </div>
        );
    }

}

const mapStateToProps = (state) => ({
    state: state
});

export default connect(mapStateToProps)(AccountDetails);
